import React from "react";
import { motion } from "framer-motion";
import { ChevronLeft } from "lucide-react";
import { Link } from "react-router-dom";

const TermsPage = () => {
  return (
    <div className="min-h-screen bg-[#050505]" data-testid="terms-page">
      {/* Back Navigation */}
      <Link 
        to="/" 
        className="fixed top-6 left-6 z-50 flex items-center gap-2 text-white/50 hover:text-white transition-colors"
        data-testid="back-to-home"
      >
        <ChevronLeft className="w-5 h-5" />
        <span className="font-accent text-sm uppercase tracking-wider">Back</span>
      </Link>

      {/* Content */}
      <div className="max-w-3xl mx-auto px-6 py-24 md:py-32">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          <h1 className="font-heading font-black text-4xl md:text-5xl uppercase tracking-tight mb-4" style={{ color: "#F4F1E8" }}>
            TERMS & <span className="text-terracotta">CONDITIONS</span>
          </h1>
          <div className="w-16 h-0.5 mb-10" style={{ background: "#D4AF37" }} />

          <div className="space-y-8 text-white/70 text-base leading-relaxed">
            <p className="text-white/50 text-sm">Last updated: January 2025</p>

            <section>
              <h2 className="font-heading font-bold text-xl text-white mb-3">Event Participation</h2>
              <p>By purchasing a ticket or participating in Cinco De Crawl events, you agree to the following:</p>
              <ul className="list-disc list-inside mt-3 space-y-2 text-white/60">
                <li>You must be 21 years of age or older to participate</li>
                <li>Valid government-issued ID is required at check-in</li>
                <li>You will comply with all venue rules and local laws</li>
                <li>You will drink responsibly and not engage in disruptive behavior</li>
              </ul>
            </section>

            <section>
              <h2 className="font-heading font-bold text-xl text-white mb-3">Ticket Policy</h2>
              <ul className="list-disc list-inside space-y-2 text-white/60">
                <li>All ticket sales are final. No refunds or exchanges.</li>
                <li>Tickets are non-transferable unless otherwise stated</li>
                <li>Lost or stolen wristbands will not be replaced</li>
                <li>VIP upgrades are subject to availability</li>
                <li>Cinco De Crawl reserves the right to modify event details</li>
              </ul>
            </section>

            <section>
              <h2 className="font-heading font-bold text-xl text-white mb-3">Assumption of Risk</h2>
              <p>By attending Cinco De Crawl events, you acknowledge and accept that:</p>
              <ul className="list-disc list-inside mt-3 space-y-2 text-white/60">
                <li>Participation involves inherent risks associated with social events and alcohol consumption</li>
                <li>You are responsible for your own safety and well-being</li>
                <li>Cinco De Crawl is not liable for personal injury, loss, or damage</li>
                <li>You voluntarily assume all risks related to participation</li>
              </ul>
            </section>

            <section>
              <h2 className="font-heading font-bold text-xl text-white mb-3">Media Release</h2>
              <p>By attending our events, you grant Cinco De Crawl permission to:</p>
              <ul className="list-disc list-inside mt-3 space-y-2 text-white/60">
                <li>Photograph, film, and record your likeness</li>
                <li>Use such media for promotional and marketing purposes</li>
                <li>Share content on social media and advertising materials</li>
              </ul>
            </section>

            <section>
              <h2 className="font-heading font-bold text-xl text-white mb-3">Code of Conduct</h2>
              <p>Participants must:</p>
              <ul className="list-disc list-inside mt-3 space-y-2 text-white/60">
                <li>Treat staff, venues, and other guests with respect</li>
                <li>Not engage in harassment, fighting, or illegal activity</li>
                <li>Follow directions from event staff and security</li>
                <li>Leave venues when asked by staff or security</li>
              </ul>
              <p className="mt-3">Violation of these terms may result in removal from the event without refund and potential ban from future events.</p>
            </section>

            <section>
              <h2 className="font-heading font-bold text-xl text-white mb-3">Contact</h2>
              <p>For questions about these Terms & Conditions, please <Link to="/contact" className="text-terracotta hover:text-terracotta-light underline">contact us</Link>.</p>
            </section>
          </div>
        </motion.div>
      </div>

      {/* Footer */}
      <footer className="py-10 px-4 border-t border-white/5" style={{ background: "#050505" }}>
        <div className="max-w-4xl mx-auto text-center">
          <h4 className="font-heading font-bold text-lg mb-1" style={{ color: "#F4F1E8" }}>
            CINCO <span className="text-terracotta">DE</span> CRAWL
          </h4>
          <p className="text-white/30 text-xs mb-4">The Ultimate Bar Crawl Tour</p>
          <p className="text-white/20 text-xs">© 2026 Cinco De Crawl. Must be 21+.</p>
        </div>
      </footer>
    </div>
  );
};

export default TermsPage;
